<div
  [attr.data-automation]="config.dataAutomation"
  [hidden]="state.hidden"
  [ngClass]="{
    'has-feedback': (showValidation || isFormSubmitted) && validationState !== ZiroFormsValidationState.VALID,
    'ziro-forms-error': (showValidation || isFormSubmitted) && validationState === ZiroFormsValidationState.INVALID,
    'ziro-forms-warning': (showValidation || isFormSubmitted) && validationState === ZiroFormsValidationState.PENDING,
  }"
>
  <div
    [class]="'card card-body d-flex flex-row ' + cardClasses()"
    [ngClass]="{ 'file-upload-card--hovering-file': isFileHovering }"
    (dragover)="dragOver($event)"
    (dragleave)="dragLeave($event)"
    (drop)="dragDrop($event)"
  >
    <div class="flex-grow-1">
      <h5 class="mb-3 strong">
        @if (config?.required) {
          <span class="ziro-forms-asterisk text-danger">*</span>
        }
        <span [innerHTML]="title | escapeHtml" data-automation="file-upload-box-title"></span>
      </h5>
      <p [innerHTML]="body | escapeHtml" class="mb-0 text-black" data-automation="file-upload-box-body"></p>
    </div>
    <div class="file-upload-area">
      <div class="file-upload-area__button">
        <label
          [for]="fieldId()"
          class="btn btn-border btn-default file-upload-area__button__label border-rad-all-8"
          data-automation="file-upload-box-button"
          [ngClass]="{
            'ziro-forms-warning':
              (showValidation || isFormSubmitted) && validationState === ZiroFormsValidationState.PENDING,
          }"
        >
          <i [class]="validationState === ZiroFormsValidationState.PENDING ? ziroIcons.SAVING : buttonIcon"></i>
          <span class="ms-1" [innerHTML]="buttonLabel | escapeHtml"></span>
        </label>
      </div>
      <input
        [id]="fieldId()"
        hidden
        type="file"
        [attr.accept]="defaultFileTypes || null"
        [multiple]="multipleFiles"
        (change)="onFileUpload($event)"
        data-automation="file-upload-box-input"
      />
      @for (file of fieldData; track file) {
        <div class="file-upload-area__file" data-automation="file-upload-box-file-details">
          <div class="file-upload-area__file__details">
            <div
              class="strong file-upload-area__file__details__name"
              data-automation="file-upload-box-file-details-name"
            >
              {{ file.name }}
            </div>
            <div class="small" data-automation="file-upload-box-file-details-size">
              {{ getHumanReadableFileSize(file.size) }}
            </div>
          </div>
          <div class="ms-2 align-content-center" data-automation="file-upload-box-file-details-remove">
            <button class="btn btn-border btn-outline-danger" (click)="removeFile(file)">
              <i [class]="ziroIcons.REMOVE"></i>
            </button>
          </div>
        </div>
      }

      <div class="ziro-forms-feedback-area">
        <div
          class="ziro-forms-validation-message"
          data-automation="ziro-forms-validation-message"
          [hidden]="!showValidation && !isFormSubmitted"
          [innerHTML]="validationMessage?.content | escapeHtml: validationMessage?.params"
        ></div>
      </div>
    </div>
  </div>
</div>
